var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerGyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.707,
    height: 23.162,
    viewBox: "0 0 39.707 23.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "burger-gy-icon",
    transform: "translate(-4.5 -10.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M42.552,13.434H6.154A1.659,1.659,0,0,1,4.5,11.779h0a1.659,1.659,0,0,1,1.654-1.654h36.4a1.659,1.659,0,0,1,1.654,1.654h0A1.659,1.659,0,0,1,42.552,13.434Z",
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M42.552,20.184H6.154A1.659,1.659,0,0,1,4.5,18.529h0a1.659,1.659,0,0,1,1.654-1.654h36.4a1.659,1.659,0,0,1,1.654,1.654h0A1.659,1.659,0,0,1,42.552,20.184Z",
    transform: "translate(0 3.177)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M42.552,26.934H6.154A1.659,1.659,0,0,1,4.5,25.279h0a1.659,1.659,0,0,1,1.654-1.654h36.4a1.659,1.659,0,0,1,1.654,1.654h0A1.659,1.659,0,0,1,42.552,26.934Z",
    transform: "translate(0 6.353)",
    fill: "#a5a5a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerGyIcon);
export default __webpack_public_path__ + "static/media/burger-gy-icon.ebe4cc576bb594f4606fe0889ce541be.svg";
export { ForwardRef as ReactComponent };